import React from 'react';

import RichText from 'components/RichText/RichText';
import { MediaCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './JoinUsHero.styles';

export interface JoinUsHeroProps {
  mediaSrc: MediaCMS;
  middleText: string;
}

const defaultProps: Partial<JoinUsHeroProps> = {};

const JoinUsHero: React.FunctionComponent<JoinUsHeroProps> = ({
  mediaSrc,
  middleText,
}) => {
  return (
    <S.JoinUsHeroWrapper url={mediaSrc?.url}>
      <RichText
        as="h1"
        size="displayHero"
        richText={middleText}
        defaultFormatting
      />
    </S.JoinUsHeroWrapper>
  );
};

JoinUsHero.defaultProps = defaultProps;

export default JoinUsHero;
